import {TranslocoService} from "@ngneat/transloco";

export class MachinePropertiesErrors {

  private machinePropertiesErrors: { [key: string]: string };


  constructor(private readonly i18n: TranslocoService) {
    this.i18n.selectTranslation().subscribe(() => {
      this.machinePropertiesErrors = {
        serial: this.i18n.translate('attribute.serialNumber'),
        alias: this.i18n.translate('attribute.alias'),
        description: this.i18n.translate('attribute.description'),
        longitude: this.i18n.translate('attribute.longitude'),
        latitude: this.i18n.translate('attribute.latitude'),
        eui: this.i18n.translate('attribute.eui'),
        organization: this.i18n.translate('attribute.organization'),
        orgCode: this.i18n.translate('attribute.orgCodeCsv'),
        orgCodeAndParentCode: this.i18n.translate('attribute.orgCodeAndParentCode'),
        parentCode: this.i18n.translate('attribute.parentCode'),
        machineModelUuid: this.i18n.translate('attribute.model'),
        automaticGeoloc: this.i18n.translate('attribute.automaticGeoloc'),
        status: this.i18n.translate('attribute.subscriptionStatus'),
        startDate: this.i18n.translate('attribute.subscriptionStart'),
        endDate: this.i18n.translate('attribute.subscriptionEnd'),
        upload: this.i18n.translate('attribute.uploadErrors')
      }
    })
  }

  public getTranslation(property): string | null {
    return this.machinePropertiesErrors.hasOwnProperty(property) ? this.machinePropertiesErrors[property] : null;
  }
}
